<template>
  <content-items-edit
    content-type="trial-reports"
    content-type-singular="trial-report"
    content-name="Trial Reports"
    content-name-singular="Trial Report"
  />
</template>

<script>
import ContentItemsEdit from '@/views/content-item/content-items-edit/ContentItemsEdit.vue'
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
    ContentItemsEdit,
  },
}
</script>

<style scoped>

</style>
